import { format, isValid, parseISO } from 'date-fns';

export function parseGuardianApiDate(raw?: string | null): Date | null {
  if (!raw) return null;

  const date = parseISO(raw);

  if (!isValid(date)) {
    return null;
  }

  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}

export function formatGuardianApiDate(
  raw: string | null | undefined,
  dateFormat: string,
  fallback = '',
) {
  const date = parseGuardianApiDate(raw);
  return date ? format(date, dateFormat) : fallback;
}
